import * as React from "react"
import { graphql } from "gatsby"
import HeroSection from "../components/Global/HeroSection"
import Layout from "../components/layout"
import Seo from "../components/seo"
import TeamPhoto from "../components/About/TeamPhoto"
import DualInfoBlock from "../components/Global/DualInfoBlock"
import InfoBlock from "../components/Global/InfoBlock"
import myphoto from "../images/Me.jpg"
import aboutphoto from "../images/about.png"

import "../components/bootstrap.min.css"
import "../components/layout.css"

const AboutPage = ({ data }) => (
  <Layout>
    <Seo title="About" />
    <HeroSection
      img={data.img.childImageSharp.fluid}
      title="about AP_Ecom"
      subtitle=""
      heroclass="about-background"
      page="/about"
    />
    <DualInfoBlock
      heading="a message from CEO"
      photo={myphoto}
      img2={data.img2.childImageSharp.fluid}
    />
    <InfoBlock heading="about vision" />
    <TeamPhoto src1={myphoto} src2={myphoto} src3={myphoto} />
  </Layout>
)
export const query = graphql`
  {
    img: file(relativePath: { eq: "about.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid_tracedSVG
        }
      }
    }
    img2: file(relativePath: { eq: "about.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid_tracedSVG
        }
      }
    }
  }
`

export default AboutPage
